import React, { ReactElement, useContext } from "react";
import { ActionType } from "../../../AppDataProvider/actions";
import { AppContext } from "../../../AppDataProvider/AppDataProvider";
import { Button } from "../index";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { marginRight } from "../../styles";
import { Mixpanel } from "../../../mixpanel/mixpanel";
import styled from "styled-components";
import { SupportedLanguage, supportedLanguages } from "../../../i18n";
import { useTranslation } from "react-i18next";
export function LanguageSelector(): ReactElement {
  const {
    t,
    i18n
  } = useTranslation();
  const {
    appDataDispatch,
    appData
  } = useContext(AppContext);
  const onSelectLanguage = async (newLanguage: string) => {
    appDataDispatch({
      type: ActionType.HIDE_NON_MODAL_DIALOG
    });
    Mixpanel.track({
      name: "Changed language",
      props: {
        from: i18n.language,
        to: newLanguage
      }
    });
    await i18n.changeLanguage(newLanguage);
  };
  let languageList = supportedLanguages;
  const language = i18n.language === "cimode" ? "en-GB" : i18n.language;
  if (appData.detectedDialect) {
    /**
     * If the dialect is detected, we need to show the dialect and the parent
     * language. Loop through the supported languages and add the dialect to
     * the next to the parent language.
     */
    const [dialect, parent] = appData.detectedDialect;
    languageList = supportedLanguages.reduce<SupportedLanguage[]>((acc, lng) => {
      const isEnglishDialect = parent === "en";
      if (lng.value === (isEnglishDialect ? "en-GB" : parent)) {
        /**
         * We need some special handling for English, as we have two dialects
         * in the selector hardcoded but no top level English language option.
         */
        acc.push({
          value: lng.value,
          label: `${lng.label}`
        });
        acc.push({
          value: dialect as SupportedLanguage["value"],
          label: `${isEnglishDialect ? "English" : lng.label} (${dialect.split("-")[1]?.toUpperCase()})`
        });
      } else {
        acc.push(lng);
      }
      return acc;
    }, []);
  }
  return <LanguageList data-sentry-element="LanguageList" data-sentry-component="LanguageSelector" data-sentry-source-file="LanguageSelector.tsx">
      {languageList.map(supportedLanguage => {
      const selected = supportedLanguage.value === language;
      const ariaLabel = selected ? t("selectedLanguageAriaLabel", {
        language: supportedLanguage.label
      }) : t("selectLanguageAriaLabel", {
        language: supportedLanguage.label
      });
      return <Button variant="tertiary" key={supportedLanguage.value} aria-label={ariaLabel} role="button" onClick={() => {
        void onSelectLanguage(supportedLanguage.value);
      }}>
            {selected && <SelectedLanguageIcon />}
            {supportedLanguage.label}
          </Button>;
    })}
    </LanguageList>;
}
const LanguageList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
const SelectedLanguageIcon = styled(FontAwesomeIcon).attrs({
  icon: faCheck
})`
  ${marginRight.s}
`;
export default LanguageSelector;